var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      on: {
        mouseenter: function ($event) {
          return _vm.cycling(false)
        },
        mouseleave: function ($event) {
          return _vm.cycling(true)
        },
      },
    },
    [
      _c(
        "v-carousel",
        {
          attrs: {
            cycle: _vm.cycle,
            "hide-delimiters": "",
            "show-arrows-on-hover": _vm.slides.length > 1 ? true : false,
            "show-arrows": _vm.slides.length > 1 ? true : false,
            light: !_vm.$vuetify.theme.dark,
            height: 425,
          },
        },
        _vm._l(_vm.slides, function (slide, i) {
          return _c(
            "v-carousel-item",
            { key: i },
            [
              slide === "npgVsXGChart" &&
              _vm.npgVsXGChart.data.labels.length > 0 &&
              _vm.npgVsXGChart.data.datasets[0].data.length > 0 &&
              _vm.npgVsXGChart.data.datasets[1].data.length > 0
                ? _c(
                    "v-card",
                    {
                      staticClass: "card-chart",
                      attrs: {
                        "min-height": "350",
                        elevation: "0",
                        outlined: "",
                        dark: _vm.$vuetify.theme.dark,
                      },
                    },
                    [
                      [
                        _c(
                          "v-card-title",
                          {
                            staticClass:
                              "py-1 white--text d-flex align-center justify-space-between",
                            class: _vm.$vuetify.theme.dark
                              ? "black"
                              : "primary",
                            staticStyle: { "flex-wrap": "nowrap" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex align-center",
                                staticStyle: {
                                  flex: "1 1 auto",
                                  "min-width": "0",
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-2",
                                    attrs: { color: "white", medium: "" },
                                  },
                                  [_vm._v("stacked_bar_chart")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "white--text body-font body-1 font-weight-bold text-uppercase text-ellipsis",
                                  },
                                  [_vm._v(_vm._s(_vm.npgVsXGChart.title))]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-menu",
                              {
                                staticStyle: { "flex-shrink": "0" },
                                attrs: { "offset-y": "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "white--text",
                                                  attrs: {
                                                    small: "",
                                                    icon: "",
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "white" } },
                                                [_vm._v("more_vert")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "v-list",
                                  { attrs: { dense: "" } },
                                  [
                                    _c(
                                      "v-list-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.saveAs(
                                              "png",
                                              "npgVsXGChart",
                                              _vm.npgVsXGChart.title
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v("PNG"),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.saveAs(
                                              "svg",
                                              "npgVsXGChart",
                                              _vm.npgVsXGChart.title
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v("SVG"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-space-between align-center px-4",
                            staticStyle: {
                              "padding-top": "0px !important",
                              "padding-bottom": "0px !important",
                            },
                          },
                          [
                            _c("div", { staticClass: "d-flex align-center" }, [
                              _vm.currentUser.team || _vm.teamId
                                ? _c("img", {
                                    staticClass: "mr-1",
                                    attrs: {
                                      src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${
                                        _vm.teamId
                                          ? _vm.teamId
                                          : _vm.currentUser.team.teamId
                                      }.png`,
                                      width: "18",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "subheader-font body-2" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.teamName
                                          ? _vm.teamName
                                          : _vm.currentUser.team
                                          ? _vm.currentUser.team.teamName
                                          : _vm.currentUser.clientName
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("v-autocomplete", {
                              staticClass: "body-2",
                              staticStyle: { "max-width": "200px" },
                              attrs: {
                                items: _vm.lastGames,
                                "item-disabled": "disabled",
                                "item-text": "name",
                                "item-value": "id",
                                "menu-props": "auto",
                                "hide-details": "",
                                dense: "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.updateDataAndRenderLineChart(
                                    _vm.npgVsXGChart,
                                    _vm.teamStatsDataAllGames,
                                    _vm.lastGamesxGvsNPGChartModel,
                                    _vm.isNeededToAccumulateStats
                                  )
                                },
                              },
                              model: {
                                value: _vm.lastGamesxGvsNPGChartModel,
                                callback: function ($$v) {
                                  _vm.lastGamesxGvsNPGChartModel = $$v
                                },
                                expression: "lastGamesxGvsNPGChartModel",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      _vm._v(" "),
                      _c("LineChart", {
                        attrs: {
                          id: "npgVsXGChart",
                          datasets: _vm.npgVsXGChart.data.datasets,
                          xAxisLabels: _vm.npgVsXGChart.data.labels,
                          gamesName: _vm.npgVsXGChart.data.gamesName,
                          options: _vm.npgVsXGChart.options,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ml-3 pb-3 primary--text subheader-font",
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: "secondary", small: "" } },
                            [_vm._v("alarm")]
                          ),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.npgVsXGChart.textFooter) +
                              "\n        "
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              slide === "xGAgainstvsNPGAgainstChart" &&
              _vm.xGAgainstvsNPGAgainstChart.data.labels.length > 0 &&
              _vm.xGAgainstvsNPGAgainstChart.data.datasets[0].data.length > 0 &&
              _vm.xGAgainstvsNPGAgainstChart.data.datasets[1].data.length > 0
                ? _c(
                    "v-card",
                    {
                      staticClass: "card-chart",
                      attrs: {
                        "min-height": "350",
                        elevation: "0",
                        outlined: "",
                        dark: _vm.$vuetify.theme.dark,
                      },
                    },
                    [
                      [
                        _c(
                          "v-card-title",
                          {
                            staticClass:
                              "py-1 white--text d-flex align-center justify-space-between",
                            class: _vm.$vuetify.theme.dark
                              ? "black"
                              : "primary",
                            staticStyle: { "flex-wrap": "nowrap" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex align-center",
                                staticStyle: {
                                  flex: "1 1 auto",
                                  "min-width": "0",
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-2",
                                    attrs: { color: "white", medium: "" },
                                  },
                                  [_vm._v("stacked_bar_chart")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "white--text body-font body-1 font-weight-bold text-uppercase text-ellipsis",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.xGAgainstvsNPGAgainstChart.title
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-menu",
                              {
                                staticStyle: { "flex-shrink": "0" },
                                attrs: { "offset-y": "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "white--text",
                                                  attrs: {
                                                    small: "",
                                                    icon: "",
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "white" } },
                                                [_vm._v("more_vert")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "v-list",
                                  { attrs: { dense: "" } },
                                  [
                                    _c(
                                      "v-list-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.saveAs(
                                              "png",
                                              "xGAgainstvsNPGAgainstChart",
                                              _vm.xGAgainstvsNPGAgainstChart
                                                .title
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v("PNG"),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.saveAs(
                                              "svg",
                                              "xGAgainstvsNPGAgainstChart",
                                              _vm.xGAgainstvsNPGAgainstChart
                                                .title
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v("SVG"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-space-between align-center px-4",
                            staticStyle: {
                              "padding-top": "0px !important",
                              "padding-bottom": "0px !important",
                            },
                          },
                          [
                            _c("div", { staticClass: "d-flex align-center" }, [
                              _vm.currentUser.team || _vm.teamId
                                ? _c("img", {
                                    staticClass: "mr-1",
                                    attrs: {
                                      src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${
                                        _vm.teamId
                                          ? _vm.teamId
                                          : _vm.currentUser.team.teamId
                                      }.png`,
                                      width: "18",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "subheader-font body-2" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.teamName
                                          ? _vm.teamName
                                          : _vm.currentUser.team
                                          ? _vm.currentUser.team.teamName
                                          : _vm.currentUser.clientName
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("v-autocomplete", {
                              staticClass: "body-2",
                              staticStyle: { "max-width": "200px" },
                              attrs: {
                                items: _vm.lastGames,
                                "item-text": "name",
                                "item-value": "id",
                                "menu-props": "auto",
                                "hide-details": "",
                                dense: "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.updateDataAndRenderLineChart(
                                    _vm.xGAgainstvsNPGAgainstChart,
                                    _vm.teamStatsDataAllGames,
                                    _vm.lastGamesxGAgainstvsNPGAgainstChartModel,
                                    _vm.isNeededToAccumulateStats
                                  )
                                },
                              },
                              model: {
                                value:
                                  _vm.lastGamesxGAgainstvsNPGAgainstChartModel,
                                callback: function ($$v) {
                                  _vm.lastGamesxGAgainstvsNPGAgainstChartModel =
                                    $$v
                                },
                                expression:
                                  "lastGamesxGAgainstvsNPGAgainstChartModel",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      _vm._v(" "),
                      _c("LineChart", {
                        attrs: {
                          id: "xGAgainstvsNPGAgainstChart",
                          datasets:
                            _vm.xGAgainstvsNPGAgainstChart.data.datasets,
                          xAxisLabels:
                            _vm.xGAgainstvsNPGAgainstChart.data.labels,
                          gamesName:
                            _vm.xGAgainstvsNPGAgainstChart.data.gamesName,
                          options: _vm.xGAgainstvsNPGAgainstChart.options,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ml-3 pb-3 primary--text subheader-font",
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: "secondary", small: "" } },
                            [_vm._v("alarm")]
                          ),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.xGAgainstvsNPGAgainstChart.textFooter
                              ) +
                              "\n        "
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              slide === "xGvsxGAgainstChart" &&
              _vm.xGvsxGAgainstChart.data.labels.length > 0 &&
              _vm.xGvsxGAgainstChart.data.datasets[0].data.length > 0 &&
              _vm.xGvsxGAgainstChart.data.datasets[1].data.length > 0
                ? _c(
                    "v-card",
                    {
                      staticClass: "card-chart",
                      attrs: {
                        elevation: "0",
                        outlined: "",
                        "min-height": "350",
                        dark: _vm.$vuetify.theme.dark,
                      },
                    },
                    [
                      [
                        _c(
                          "v-card-title",
                          {
                            staticClass:
                              "py-1 white--text d-flex align-center justify-space-between",
                            class: _vm.$vuetify.theme.dark
                              ? "black"
                              : "primary",
                            staticStyle: { "flex-wrap": "nowrap" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex align-center",
                                staticStyle: {
                                  flex: "1 1 auto",
                                  "min-width": "0",
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-2",
                                    attrs: { color: "white", medium: "" },
                                  },
                                  [_vm._v("stacked_bar_chart")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "white--text body-font body-1 font-weight-bold text-uppercase text-ellipsis",
                                  },
                                  [_vm._v(_vm._s(_vm.xGvsxGAgainstChart.title))]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-menu",
                              {
                                staticStyle: { "flex-shrink": "0" },
                                attrs: { "offset-y": "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "white--text",
                                                  attrs: {
                                                    small: "",
                                                    icon: "",
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "white" } },
                                                [_vm._v("more_vert")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "v-list",
                                  { attrs: { dense: "" } },
                                  [
                                    _c(
                                      "v-list-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.saveAs(
                                              "png",
                                              "xGvsxGAgainstChart",
                                              _vm.xGvsxGAgainstChart.title
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v("PNG"),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.saveAs(
                                              "svg",
                                              "xGvsxGAgainstChart",
                                              _vm.xGvsxGAgainstChart.title
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v("SVG"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-space-between align-center px-4",
                            staticStyle: {
                              "padding-top": "0px !important",
                              "padding-bottom": "0px !important",
                            },
                          },
                          [
                            _c("div", { staticClass: "d-flex align-center" }, [
                              _vm.currentUser.team || _vm.teamId
                                ? _c("img", {
                                    staticClass: "mr-1",
                                    attrs: {
                                      src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${
                                        _vm.teamId
                                          ? _vm.teamId
                                          : _vm.currentUser.team.teamId
                                      }.png`,
                                      width: "18",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "subheader-font body-2" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.teamName
                                          ? _vm.teamName
                                          : _vm.currentUser.team
                                          ? _vm.currentUser.team.teamName
                                          : _vm.currentUser.clientName
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("v-autocomplete", {
                              staticClass: "body-2",
                              staticStyle: { "max-width": "200px" },
                              attrs: {
                                items: _vm.lastGames,
                                "item-text": "name",
                                "item-value": "id",
                                "menu-props": "auto",
                                "hide-details": "",
                                dense: "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.updateDataAndRenderLineChart(
                                    _vm.xGvsxGAgainstChart,
                                    _vm.teamStatsDataAllGames,
                                    _vm.lastGamesxGvsxGAgainstChartModel,
                                    !_vm.isNeededToAccumulateStats
                                  )
                                },
                              },
                              model: {
                                value: _vm.lastGamesxGvsxGAgainstChartModel,
                                callback: function ($$v) {
                                  _vm.lastGamesxGvsxGAgainstChartModel = $$v
                                },
                                expression: "lastGamesxGvsxGAgainstChartModel",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      _vm._v(" "),
                      _c("LineChart", {
                        attrs: {
                          id: "xGvsxGAgainstChart",
                          datasets: _vm.xGvsxGAgainstChart.data.datasets,
                          xAxisLabels: _vm.xGvsxGAgainstChart.data.labels,
                          gamesName: _vm.xGvsxGAgainstChart.data.gamesName,
                          options: _vm.xGvsxGAgainstChart.options,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ml-3 pb-3 primary--text subheader-font",
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: "secondary", small: "" } },
                            [_vm._v("alarm")]
                          ),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.xGvsxGAgainstChart.textFooter) +
                              "\n        "
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              slide === "pointsVsXPointsChart" &&
              _vm.pointsVsXPointsChart.data.labels.length > 0 &&
              _vm.pointsVsXPointsChart.data.datasets[0].data.length > 0 &&
              _vm.pointsVsXPointsChart.data.datasets[1].data.length > 0
                ? _c(
                    "v-card",
                    {
                      staticClass: "card-chart",
                      attrs: {
                        "min-height": "350",
                        elevation: "0",
                        outlined: "",
                        dark: _vm.$vuetify.theme.dark,
                      },
                    },
                    [
                      [
                        _c(
                          "v-card-title",
                          {
                            staticClass:
                              "py-1 white--text d-flex align-center justify-space-between",
                            class: _vm.$vuetify.theme.dark
                              ? "black"
                              : "primary",
                            staticStyle: { "flex-wrap": "nowrap" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex align-center",
                                staticStyle: {
                                  flex: "1 1 auto",
                                  "min-width": "0",
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-2",
                                    attrs: { color: "white", medium: "" },
                                  },
                                  [_vm._v("stacked_bar_chart")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "white--text body-font body-1 font-weight-bold text-uppercase text-ellipsis",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.pointsVsXPointsChart.title)
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-menu",
                              {
                                staticStyle: { "flex-shrink": "0" },
                                attrs: { "offset-y": "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "white--text",
                                                  attrs: {
                                                    small: "",
                                                    icon: "",
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "white" } },
                                                [_vm._v("more_vert")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "v-list",
                                  { attrs: { dense: "" } },
                                  [
                                    _c(
                                      "v-list-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.saveAs(
                                              "png",
                                              "pointsVsXPointsChart",
                                              _vm.pointsVsXPointsChart.title
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v("PNG"),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.saveAs(
                                              "svg",
                                              "pointsVsXPointsChart",
                                              _vm.pointsVsXPointsChart.title
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v("SVG"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-space-between align-center px-4",
                            staticStyle: {
                              "padding-top": "0px !important",
                              "padding-bottom": "0px !important",
                            },
                          },
                          [
                            _c("div", { staticClass: "d-flex align-center" }, [
                              _vm.currentUser.team || _vm.teamId
                                ? _c("img", {
                                    staticClass: "mr-1",
                                    attrs: {
                                      src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${
                                        _vm.teamId
                                          ? _vm.teamId
                                          : _vm.currentUser.team.teamId
                                      }.png`,
                                      width: "18",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "subheader-font body-2" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.teamName
                                          ? _vm.teamName
                                          : _vm.currentUser.team
                                          ? _vm.currentUser.team.teamName
                                          : _vm.currentUser.clientName
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("v-autocomplete", {
                              staticClass: "body-2",
                              staticStyle: { "max-width": "200px" },
                              attrs: {
                                items: _vm.lastGames,
                                "item-text": "name",
                                "item-value": "id",
                                "menu-props": "auto",
                                "hide-details": "",
                                dense: "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.updateDataAndRenderLineChart(
                                    _vm.pointsVsXPointsChart,
                                    _vm.teamStatsDataAllGames,
                                    _vm.lastGamesxPointsvsPointsChartModel,
                                    _vm.isNeededToAccumulateStats
                                  )
                                },
                              },
                              model: {
                                value: _vm.lastGamesxPointsvsPointsChartModel,
                                callback: function ($$v) {
                                  _vm.lastGamesxPointsvsPointsChartModel = $$v
                                },
                                expression:
                                  "lastGamesxPointsvsPointsChartModel",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      _vm._v(" "),
                      _c("LineChart", {
                        attrs: {
                          id: "pointsVsXPointsChart",
                          datasets: _vm.pointsVsXPointsChart.data.datasets,
                          xAxisLabels: _vm.pointsVsXPointsChart.data.labels,
                          gamesName: _vm.pointsVsXPointsChart.data.gamesName,
                          options: _vm.pointsVsXPointsChart.options,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ml-3 pb-3 primary--text subheader-font",
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: "secondary", small: "" } },
                            [_vm._v("alarm")]
                          ),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.pointsVsXPointsChart.textFooter) +
                              "\n        "
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              slide === "playerReportsChart"
                ? _c(
                    "v-card",
                    {
                      staticClass: "card-chart",
                      attrs: {
                        "min-height": "350",
                        elevation: "0",
                        outlined: "",
                        dark: _vm.$vuetify.theme.dark,
                      },
                    },
                    [
                      [
                        _c(
                          "v-card-title",
                          {
                            staticClass: "py-1 white--text d-flex align-center",
                            class: _vm.$vuetify.theme.dark
                              ? "black"
                              : "primary",
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "mr-2",
                                attrs: { color: "white", medium: "" },
                              },
                              [_vm._v("stacked_bar_chart")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "white--text body-font body-1 font-weight-bold text-uppercase",
                              },
                              [_vm._v(_vm._s(_vm.playerReportsChart.title))]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-space-between align-center px-4",
                            staticStyle: {
                              "padding-top": "0px !important",
                              "padding-bottom": "0px !important",
                            },
                          },
                          [
                            _c("div", { staticClass: "d-flex align-center" }, [
                              _vm.currentUser.team || _vm.teamId
                                ? _c("img", {
                                    staticClass: "mr-1",
                                    attrs: {
                                      src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${
                                        _vm.teamId
                                          ? _vm.teamId
                                          : _vm.currentUser.team.teamId
                                      }.png`,
                                      width: "18",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "subheader-font body-2" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.teamName
                                          ? _vm.teamName
                                          : _vm.currentUser.team
                                          ? _vm.currentUser.team.teamName
                                          : _vm.currentUser.clientName
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("v-autocomplete", {
                              staticClass: "body-2",
                              staticStyle: { "max-width": "200px" },
                              attrs: {
                                items: _vm.reportTypes,
                                "item-text": "name",
                                "item-value": "id",
                                "menu-props": "auto",
                                "hide-details": "",
                                dense: "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.updateDataAndRenderPlayersReportChartData()
                                },
                              },
                              model: {
                                value: _vm.reportTypesModel,
                                callback: function ($$v) {
                                  _vm.reportTypesModel = $$v
                                },
                                expression: "reportTypesModel",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      _vm._v(" "),
                      _c("BarChart", {
                        attrs: {
                          id: "playerReportsChart",
                          datasets: _vm.playerReportsChart.data.datasets,
                          xAxisLabels: _vm.playerReportsChart.data.labels,
                          options: _vm.playerReportsChart.options,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ml-3 pb-3 primary--text subheader-font",
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: "primary", small: "" } },
                            [_vm._v("bar_chart")]
                          ),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.playerReportsChart.textFooter) +
                              "\n        "
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              slide === "playerScoutChart"
                ? _c(
                    "v-card",
                    {
                      staticClass: "card-chart",
                      attrs: {
                        "min-height": "350",
                        elevation: "0",
                        outlined: "",
                        dark: _vm.$vuetify.theme.dark,
                      },
                    },
                    [
                      [
                        _c(
                          "v-card-title",
                          {
                            staticClass: "py-1 white--text d-flex align-center",
                            class: _vm.$vuetify.theme.dark
                              ? "black"
                              : "primary",
                            staticStyle: { "flex-wrap": "nowrap" },
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "mr-2",
                                attrs: { color: "white", medium: "" },
                              },
                              [_vm._v("stacked_bar_chart")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "white--text body-font body-1 font-weight-bold text-uppercase",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.playerScoutChart.title) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-space-between align-center px-4 pt-2 pb-1",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-center flex-wrap" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "body-2 mr-2 d-none d-sm-inline-flex",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("charts.showLeaguesWithAtLeast")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                staticStyle: { "max-width": "70px" },
                                attrs: {
                                  type: "number",
                                  dense: "",
                                  "hide-details": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.updateDataAndRenderPlayersScoutedChartData()
                                  },
                                },
                                model: {
                                  value: _vm.minPlayersForLeague,
                                  callback: function ($$v) {
                                    _vm.minPlayersForLeague = _vm._n($$v)
                                  },
                                  expression: "minPlayersForLeague",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "body-2 mr-4 d-none d-sm-inline-flex",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("charts.playersScoutedSuffix")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "d-flex align-center",
                              staticStyle: { "flex-shrink": "0" },
                            },
                            [
                              _c("v-autocomplete", {
                                staticClass: "body-2",
                                staticStyle: { "max-width": "200px" },
                                attrs: {
                                  items: _vm.reportTypes,
                                  "item-text": "name",
                                  "item-value": "id",
                                  "menu-props": "auto",
                                  "hide-details": "",
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.updateDataAndRenderPlayersScoutedChartData()
                                  },
                                },
                                model: {
                                  value: _vm.scoutTypesModel,
                                  callback: function ($$v) {
                                    _vm.scoutTypesModel = $$v
                                  },
                                  expression: "scoutTypesModel",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("BarChart", {
                        attrs: {
                          id: "playerScoutChart",
                          datasets: _vm.playerScoutChart.data.datasets,
                          xAxisLabels: _vm.playerScoutChart.data.labels,
                          options: _vm.playerScoutChart.options,
                          "crest-urls": _vm.playerScoutChart.crests,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "ml-3 pb-3 primary--text subheader-font d-flex align-center",
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-1",
                              attrs: { color: "primary", small: "" },
                            },
                            [_vm._v("alarm")]
                          ),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.playerScoutChart.textFooter) +
                              "\n        "
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c("ChartExportLinksModal", {
        ref: "chartExportLinksModalRef",
        attrs: { title: _vm.teamName, subtitle: _vm.embedSubtitle },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }